import { createTheme } from "@mui/material/styles";
import { orange } from "@mui/material/colors";

const fontWeightsClasses = {
  "&.font-w-100": {
    fontWeight: 100,
  },
  "&.font-w-200": {
    fontWeight: 200,
  },
  "&.font-w-300": {
    fontWeight: 300,
  },
  "&.font-w-400": {
    fontWeight: 400,
  },
  "&.font-w-500": {
    fontWeight: 500,
  },
  "&.font-w-600": {
    fontWeight: 600,
  },
  "&.font-w-700": {
    fontWeight: 700,
  },
  "&.font-w-800": {
    fontWeight: 800,
  },
  "&.font-w-900": {
    fontWeight: 900,
  },
};

const fontColorClasses = {
  "&.white-color": {
    color: "#fff",
  },
  "&.gray-color": {
    color: "#919191"
  },
  "&.gray-color-1": {
    color:"#ACACB1"
  },
  "&.black-color": {
    color: "#000000",
  },
  "&.black-color-2": {
    color: "#3A3A3B",
  },
  "&.black-color-3":{
    color:"#999999"
  },
  "&.black-color-4":{
    color:"#1E293B" 
  },
  "&.black-color-5":{
    color:" #475467"
  },
  "&.green-color": {
    color: "#128455",
  },
  "&.blue-color": {
    color: "#00A7FF",
  },
};

const commonTextClasses = {
  "&.text-nowrap": {
    whiteSpace: "nowrap",
  },
  "&.text-center": {
    textAlign: "center",
  },
  "&.text-right": {
    textAlign: "right",
  },
};

export const theme = createTheme({
  status: {
    danger: orange[500],
  },
  palette: {
    primary: {
      main: "#000",
      contrastText: "#464255",
    },
    secondaryText: {
      main: "#fff0",
      contrastText: "#A3A3A3",
    },
    buttonNormal: {
      main: "#F3F2F7",
      contrastText: "#464255",
      ":disabled": {
        backgroundColor: "#ff0",
      },
    },
  },
  components: {
    // Name of the component
    MuiButton: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          border: "auto",
          textTransform: "none",
          // boxShadow: "none",
          // textTransform: "none",
          "&.mozPrimaryColorButton": {
            color: "white",
            backgroundColor: "transparent",
            borderColor: "white",
            "&:hover": {
              backgroundColor: "#DF0E0E",
              borderColor: "#DF0E0E !important",
            },
            "&:disabled": {
              backgroundColor: "rgba(255,255,255,0.25)",
            },
            "&:focus": {
              backgroundColor: "#DF0E0E",
              borderColor: "#DF0E0E !important",
            },
            "&.mozButtonSelected": {
              backgroundColor: "#DF0E0E",
              borderColor: "#DF0E0E !important",
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          //   paddingRight: "32px",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          //   "transparent-dialog": {
          //     backgroundColor: "transparent",
          //   },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          margin: "5px 0",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          "& fieldset": {
            borderColor: "#ACACB1",
          },
          "& fieldset.rounded": {
            borderRadius: 4,
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "input:disabled": {
            cursor: "not-allowed",
          },
          ".Mui-disabled": {
            cursor: "not-allowed",
          },
        },
      },
      defaultProps: {
        typographyprops: {
          variant: "xlSize",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          // "&.BrandRoundIconContainer": {
          //   borderRadius: "50%",
          //   padding: "7px",
          //   backgroundColor: "inherit",
          //   "&:hover": {
          //     backgroundColor: "inherit",
          //   },
          // },
        },
        // Name of the slot
      },
    },
    MuiTypography: {
      styleOverrides: {
        // Name of the slot
        root: {
          "&.mozHeaderNavTypo": {
            color: "white",
            textDecoration: "none",
            "&:hover": {
              color: "#DF0E0E",
            },
            "&:focus": {
              color: "#DF0E0E",
            },
            "&.mozNavSelected": {
              color: "#DF0E0E",
            },
          },
          "&.mozFooterNavTypo": {
            color: "#A9A9A9",
            textDecoration: "none",
            "&:hover": {
              color: "#242424",
            },
            "&:focus": {
              color: "#242424",
            },
            "&.mozNavSelected": {
              color: "#242424",
            },
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          //   "&.Mui-selected": {
          //     backgroundColor: "#b8dcfa26",
          //   },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          //   background: "#fff",
          //   "&:hover": {
          //     background: "#fff",
          //   },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        ".py0": {
          paddingBottom: "0px !important",
          paddingTop: "0px !important",
        },
        ".rounded-2": {
          borderRadius: 8,
        },
        ".rounded-3": {
          borderRadius: 16,
        },
      },
    },
  },
  typography: {
    fs12: {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      fontStyle: "normal",
      fontSize: "12px",
      lineHeight: "15.12px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
    },
    fs14: {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "17.64px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
    },
    fs16: {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      fontStyle: "normal",
      fontSize: "16px",
      lineHeight: "20.16px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
    },
    fs20: {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      fontStyle: "normal",
      fontSize: "20px",
      lineHeight: "25.2px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
    },
    xxxxsSize: {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "28px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
      "@media only screen and (min-width: 280px) and (max-width: 500px)": {
        fontSize: "12px",
        lineHeight: "24px",
      },
      "@media only screen and (min-width: 501px) and (max-width: 767px)": {
        fontSize: "12px",
        lineHeight: "24px",
      },
    },

    xxxsSize: {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      fontStyle: "normal",
      fontSize: "13px",
      lineHeight: "15.6px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
      "@media only screen and (min-width: 280px) and (max-width: 500px)": {
        fontSize: "12px",
        lineHeight: "14px",
      },
      "@media only screen and (min-width: 501px) and (max-width: 767px)": {
        fontSize: "12px",
        lineHeight: "14px",
      },
    },
    xxsSize: {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      fontStyle: "normal",
      fontSize: "16px",
      lineHeight: "28px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
      
      "@media only screen and (min-width: 280px) and (max-width: 500px)": {
        fontSize: "13px",
        lineHeight: "16px",
      },
      "@media only screen and (min-width: 501px) and (max-width: 767px)": {
        fontSize: "15px",
        lineHeight: "18px",
      },
    },
    xsSize: {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      fontStyle: "normal",
      fontSize: "18px",
      lineHeight: "24px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
      
      "@media only screen and (min-width: 280px) and (max-width: 500px)": {
        fontSize: "14px",
        lineHeight: "16px",
      },
      "@media only screen and (min-width: 501px) and (max-width: 767px)": {
        fontSize: "16px",
        lineHeight: "18px",
      },
    },
    sSize: {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      fontStyle: "normal",
      fontSize: "20px",
      lineHeight: "24px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
     
      "@media only screen and (min-width: 280px) and (max-width: 500px)": {
        fontSize: "16px",
        lineHeight: "18px",
      },
      "@media only screen and (min-width: 501px) and (max-width: 767px)": {
        fontSize: "16px",
        lineHeight: "18px",
      },
      "@media only screen and (min-width: 768px) and (max-width: 1023px)": {
        fontSize: "20px",
        lineHeight: "24px",
      },
    },
    smSize: {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      fontStyle: "normal",
      fontSize: "20px",
      lineHeight: "22px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
     
      "@media only screen and (min-width: 280px) and (max-width: 500px)": {
        fontSize: "16px",
        lineHeight: "18px",
      },
      "@media only screen and (min-width: 501px) and (max-width: 767px)": {
        fontSize: "16px",
        lineHeight: "18px",
      },
      "@media only screen and (min-width: 768px) and (max-width: 1023px)": {
        fontSize: "20px",
        lineHeight: "24px",
      },
    }
    ,
    mSize: {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      fontStyle: "normal",
      fontSize: "24px",
      lineHeight: "30.24px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
     
      "@media only screen and (min-width: 280px) and (max-width: 500px)": {
        fontSize: "16px",
        lineHeight: "20.16px",
      },
      "@media only screen and (min-width: 501px) and (max-width: 767px)": {
        fontSize: "16px",
        lineHeight: "20.16px",
      },
      "@media only screen and (min-width: 768px) and (max-width: 900px)": {
        fontSize: "16px",
        lineHeight: "20.16px",
      },
      "@media only screen and (min-width: 900px) and (max-width: 1023px)": {
        fontSize: "24px",
        lineHeight: "30.24px",
      },
      "@media only screen and (min-width: 1024px) and (max-width: 1439px)": {
        fontSize: "24px",
        lineHeight: "30.24px",
      },
    },
    lSize: {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      fontStyle: "normal",
      fontSize: "30px",
      lineHeight: "37.8px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
    
      "@media only screen and (min-width: 280px) and (max-width: 500px)": {
        fontSize: "14px",
        lineHeight: "17.64px",
      },
      "@media only screen and (min-width: 501px) and (max-width: 767px)": {
        fontSize: "14px",
        lineHeight: "17.64px",
      },
      "@media only screen and (min-width: 768px) and (max-width: 900px)": {
        fontSize: "14px",
        lineHeight: "17.64px",
      },
      "@media only screen and (min-width: 900px) and (max-width: 1023px)": {
        fontSize: "30px",
      lineHeight: "37.8px",
      },
      "@media only screen and (min-width: 1024px) and (max-width: 1439px)": {
        fontSize: "30px",
        lineHeight: "37.8px",
      },
    },
    xlSize: {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      fontStyle: "normal",
      fontSize: "32px",
      lineHeight: "32px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
    
      "@media only screen and (min-width: 280px) and (max-width: 500px)": {
        fontSize: "20px",
        lineHeight: "24px",
      },
      "@media only screen and (min-width: 501px) and (max-width: 767px)": {
        fontSize: "20px",
        lineHeight: "24px",
      },
      "@media only screen and (min-width: 768px) and (max-width: 1023px)": {
        fontSize: "32px",
        lineHeight: "32px",
      },
      "@media only screen and (min-width: 1024px) and (max-width: 1439px)": {
        fontSize: "32px",
        lineHeight: "32px",
      },
    },
    xxlSize: {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      fontStyle: "normal",
      fontSize: "39px",
      lineHeight: "46.8px",
      ...fontWeightsClasses,
      ...fontColorClasses,
      ...commonTextClasses,
      
      "@media only screen and (min-width: 280px) and (max-width: 500px)": {
        fontSize: "28px",
        lineHeight: "32px",
      },
      "@media only screen and (min-width: 501px) and (max-width: 767px)": {
        fontSize: "32px",
        lineHeight: "45px",
      },
      "@media only screen and (min-width: 768px) and (max-width: 1023px)": {
        fontSize: "32px",
        lineHeight: "45px",
      },
      "@media only screen and (min-width: 1024px) and (max-width: 1439px)": {
        fontSize: "39px",
        lineHeight: "46.8px",
      },
    },
    
  },
  shape: {
    borderRadiusPrimary: (val) => val,
  },
  shape: {
    borderRadius: (val) => 2 * val,
  },
});
